// extracted by mini-css-extract-plugin
export default {"card":"Card_card__k61Tw","small":"Card_small__pwpoe","title":"Card_title__cIt+7","cover":"Card_cover__qCn2p","tags":"Card_tags__CXQ-+"};